<template>
    <div class="body">
        <div class="back" @click="$router.go(-1)">
            <img src="../../assets/img/i19.png" />
            返回
        </div>
        <div class="content">
            <div class="top">
                <div class="t_tab" :class="tab == 0 ? 'tt' : ''" @click="btn_tab(0)">智能{{ type == 1 ? '课堂':'会议' }}</div>
                <div class="t_tab" :class="tab == 1 ? 'tt' : ''" @click="btn_tab(1)">{{type == 1 ? '课堂' : '会议'}}原文</div>
            </div>
            <div class="bottom">
                <div class="item" v-for="(item, index) in list" :key="index" v-if="tab == 0 && list.length > 0 && type == 1">
                    <div class="i_top">
                        <div class="it_left">
                            <img :src="index == 0 ? require('@/assets/img/i404.png') : index == 1 ? require('@/assets/img/i405.png') : require('@/assets/img/i406.png')" />
                            {{ index == 0 ? '课堂转文章' : index == 1 ? '课堂环节' : '课堂分析报告' }}
                        </div>
                        <div class="it_right" @click="btn_down(item.id)">
                            <img src="../../assets/img/i37.png" />
                            下载
                        </div>
                    </div>
                    <div class="i_bottom" v-html="markedt(preprocessLaTeX(item.aiAnalysis))"></div>
                </div>
                <div class="item" v-for="(item, index) in list" :key="index" v-if="tab == 0 && list.length > 0 && type == 2 && index < 2">
                    <div class="i_top">
                        <div class="it_left">
                            <img :src="index == 0 ? require('@/assets/img/i404.png') : index == 1 ? require('@/assets/img/i405.png') : require('@/assets/img/i406.png')" />
                            {{ index == 0 ? '逐字稿文章' : index == 1 ? '纪要梳理' : '' }}
                        </div>
                        <div class="it_right" @click="btn_down(item.id)">
                            <img src="../../assets/img/i37.png" />
                            下载
                        </div>
                    </div>
                    <div class="i_bottom" v-html="markedt(preprocessLaTeX(item.aiAnalysis))"></div>
                </div>
                <div class="item" v-if="tab == 1">
                    <div class="i_bottom" v-for="(item, index) in formatContent(content)" :key="index">{{ item.text }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    transRecordStatus,
    transRecordContent,
    transRecordAnalysis,
    transRecordFilePath,
    transRecordSaveFile,
    transRecordTransFilePath,
    transRecordSaveTransFile
} from '@/apis/index'
// import mk from 'markdown-it-katex';
import '@/assets/katex/dist/katex.min.css';
import markdownItKatex from '@iktakahiro/markdown-it-katex';
import MarkdownIt from 'markdown-it'
const markdownRender = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
    breaks: true
});
markdownRender.use(markdownItKatex);
export default {
    data() {
        return {
            tab: 0,
            id: '',
            content: '',
            list: [],
            status: null,
            timer: '',
            type:null
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        this.type = this.$route.query.type;
            this.getStatus();
    },
    destroyed() {
        clearInterval(this.timer)
    },
    methods: {
        markedt(markdown) {
            markdown = markdown.replace(/\$(.*?)\$/g, (match, p1) => {
                // 在匹配的内容中替换乘号和 \frac
                const replaced = p1
                    .replace(/×/g, '\\times') // 替换乘号
                    // .replace(/\frac/g, '\\\\frac'); // 替换 \frac
                return `$${replaced}$`; // 返回替换后的内容
            });
            if (markdown) {
                return markdownRender.render(markdown);
            }
            return '';
        },
        btn_down(id) {
            if (id) {
                transRecordFilePath(id).then((resA) => {
                    console.log(resA, 'transRecordFilePath');
                    transRecordSaveFile(id).then((resB) => {
                        console.log(resB, 'transRecordSaveFile');
                        this.$message.success('已下载至[我的知识库-个人]中');
                    });
                });
            } else {
                console.log(this.id, 'this.id');
                transRecordTransFilePath(this.id).then((resA) => {
                    console.log(resA, 'transRecordTransFilePath');
                    transRecordSaveTransFile(this.id).then((resB) => {
                        console.log(resB, 'transRecordSaveTransFile');
                        this.$message.success('已下载至[我的知识库-个人]中');
                    });
                });
            }
        },
        btn_tab(tab) {
            this.tab = tab;
            this.getStatus()
        },
        getAnalysis() {
            transRecordAnalysis(this.id).then((res) => {
                console.log(res, 'transRecordAnalysis');
                res.data.forEach(e => { e.flag = 0 })
                this.list = res.data;
            });
        },
        getContent() {
            transRecordContent(this.id).then((res) => {
                console.log(res, 'transRecordContent');
                this.content = res.data.transText;
            });
        },
        getStatus() {
            transRecordStatus(this.id).then((res) => {
                console.log(res, 'transRecordStatus');
                this.status = res.data
                if (this.status == 2 && this.tab == 0) {
                    clearInterval(this.timer)
                    this.getAnalysis();
                } else if (this.status != 2 && this.tab == 0) {
                    if (!this.timer) {
                        this.timer = setInterval(() => {
                            this.getStatus()
                        }, 5000)
                    }
                } else if (this.tab == 1) {
                    this.getContent();
                }
            });
        },
        formatContent(text) {
            // 分割文本为数组
            var sentences = text.split('。');
            // 转换为 [{text: '', id: ''}] 格式
            var result = sentences
                .map((sentence, index) => {
                    // 去除句子前后的空白字符
                    sentence = sentence.trim();
                    return {
                        text: sentence, // 句子内容
                        id: index + 1, // 生成唯一 id（从 1 开始）
                    };
                })
                .filter((item) => item.text !== ''); // 过滤掉空句子
            return result;
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep {
  code {
    /*元素内的空白保留，并允许换行*/
    white-space: pre-wrap !important;
    /*是否允许在单词内断句*/
    word-wrap: break-word !important;
    font-family: PingFang;
  }

  .katex-html {
    // display: none !important;
  }

  annotation {
    display: none !important;
  }

  table {
    border-collapse: collapse;
    /* 确保表格的边框线会合并为单一的线条 */
    border: 1px solid black;
    /* 设置表格的边框 */
  }

  td,
  th {
    border: 1px solid black;
    /* 设置单元格的边框 */
  }

  h1 {
    font-size: 16px;
    font-weight: bold;
  }

  h2 {
    font-size: 16px;
    font-weight: bold;
  }

  h3 {
    font-size: 16px;
    font-weight: bold;
  }

  p {
    font-size: 16px;
  }

  li {
    font-size: 16px;
  }
}
.body {
    width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .back {
        width: 100%;
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 14px;
        color: #000000;
        margin-bottom: 10px;
        margin-top: 10px;
        cursor: pointer;

        img {
            width: 14px;
            height: 14px;

        }
    }

    .content {
        width: 100%;
        height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        .top {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .t_tab {
                width: 108px;
                height: 34px;
                background: #FFFFFF;
                border-radius: 8px 8px 8px 8px;
                border: 1px solid #E9EBF2;
                font-weight: 500;
                font-size: 14px;
                color: #333333;
                text-align: center;
                line-height: 34px;
                margin: 0 5px;
                cursor: pointer;
            }

            .tt {
                color: #FFFFFF !important;
                background: #2992FF !important;
            }
        }

        .bottom::-webkit-scrollbar {
            display: none;
        }

        .bottom {
            width: 1000px;
            height: 0;
            flex: 1;
            overflow-y: scroll;
            margin-top: 20px;

            .item {
                width: 100%;
                background: #FFFFFF;
                border-radius: 10px 10px 10px 10px;
                box-sizing: border-box;
                padding: 20px;
                margin-bottom: 20px;

                .i_top {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 10px;

                    .it_left {
                        display: flex;
                        align-items: center;
                        font-weight: bold;
                        font-size: 22px;
                        color: #333333;

                        img {
                            width: 30px;
                            height: 30px;
                            margin-right: 10px;
                        }
                    }

                    .it_right {
                        display: flex;
                        align-items: center;
                        font-weight: 500;
                        font-size: 14px;
                        color: #333333;
                        cursor: pointer;

                        img {
                            width: 14px;
                            height: 14px;
                            margin-right: 8px;
                        }
                    }
                }

                .i_bottom {
                    font-weight: 400;
                    font-size: 16px;
                    color: #333333;
                    line-height: 32px;
                }
            }
        }
    }
}
</style>